import React from "react";
import { useSelector } from "types/store";
import { getHasNewFineTunedModel } from "containers/ChatApp/reducer";
import styles from "./style.module.css";
const NewFineTunedModelBadge = ({ id }) => {
    const shouldShow = useSelector((state) => getHasNewFineTunedModel(state, id));
    if (!shouldShow) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: styles.newFineTunedModelBadgeWrapper },
        React.createElement("div", { className: styles.newFineTunedModelBadge },
            React.createElement("div", { className: styles.newFineTunedModelBadgeText }, "New Aible Intern Available"))));
};
export default NewFineTunedModelBadge;
